import { render, staticRenderFns } from "./topCarousel.vue?vue&type=template&id=5cfd930c&scoped=true&"
import script from "./topCarousel.vue?vue&type=script&lang=js&"
export * from "./topCarousel.vue?vue&type=script&lang=js&"
import style0 from "./topCarousel.vue?vue&type=style&index=0&id=5cfd930c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfd930c",
  null
  
)

export default component.exports